import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    hasVisibleData: boolean;
    legendPosition: 'left' | 'right';
  }>()
  .create(({ hasVisibleData, legendPosition }) => {
    const getFlexDirection = () => {
      if (legendPosition === 'right') {
        return 'row-reverse';
      }
      return 'row';
    };

    return {
      donutChart: {
        height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        padding: 0,
        width: '100%'
      },
      donutChartContainer: {
        flex: hasVisibleData ? '0 0 40%' : '0 0 100%',
        height: '100%',
        maxHeight: '100%',
        minHeight: 0,
        overflow: 'hidden',
        position: 'relative'
      },
      donutChartLegendContainer: {
        padding: '0 0.5rem',
        width: '100%'
      },
      donutChartLegend: {
        flex: 1,
        height: '100%',
        justifyContent: 'center',
        minWidth: '0.5rem'
      },
      donutChartWrapper: {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: getFlexDirection(),
        gap: 0.5,
        height: '100%',
        maxHeight: '100%',
        overflow: 'hidden'
      }
    };
  });

export default useStyles;
